import { useEffect } from 'react'
import { enqueueSnackbar } from 'notistack'
import { useNavigate, useSearchParams } from 'react-router-dom-v5-compat'
import { useUser } from '~/common/hooks'
import { getPath } from '~/utils'

function getErrorParamMessage(error: string) {
    if (error.startsWith('checkout_')) {
        return gettext('Failed to checkout')
    }

    return gettext('Error')
}

export default function HomePage() {
    const navigate = useNavigate()
    const { permissions } = useUser()
    const [searchParams] = useSearchParams()

    useEffect(() => {
        let redirectPath = ''
        if (permissions.some((p) => p.codename === 'module.sales')) {
            redirectPath = getPath('sales')
        } else if (permissions.some((p) => p.codename === 'module.products')) {
            redirectPath = getPath('products')
        } else if (permissions.some((p) => p.codename === 'module.analytics')) {
            redirectPath = getPath('dashboardOverview')
        } else {
            redirectPath = getPath('accessDenied')
        }

        navigate(redirectPath, { replace: true })
    }, [permissions, navigate])

    useEffect(() => {
        const error = searchParams.get('error')
        if (error) {
            enqueueSnackbar(getErrorParamMessage(error), {
                variant: 'error',
            })
        }
    }, [searchParams])

    return null
}
